import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { NgrxService } from 'src/app/services/ngrx/ngrx.service';

@Injectable({
	providedIn: 'root',
})
export class EmailServiceService {
	constructor(private http: HttpClient, private ngrxService: NgrxService) {}

	loadinit() {
		return this.ngrxService.loadInitAPI('EmailTemplate', 'list');
	}

	loadapi() {
		return this.getEmailTemplateList().pipe(
			map((data: any) => {
				return this.ngrxService.loadInitData(
					'EmailTemplate',
					'list',
					data.Items,
				);
			}),
		);
	}

	fetchdata() {
		return this.ngrxService.loadData('EmailTemplate', 'list');
	}

	getEmailTemplateList() {
		return this.http.get(
			'https://71bva67e94.execute-api.us-east-1.amazonaws.com/dev/application/emailTemplate/fetch/all',
		);
	}

	getEmailTemplateById(name: string | null) {
		return this.http.get(
			'https://71bva67e94.execute-api.us-east-1.amazonaws.com/dev/application/emailTemplate/' +
				name,
		);
	}

	updateEmailTemplate(obj: {
		courseId: number;
		emailTemplate: string;
		subject: string;
		body: string;
	}) {
		return this.http.post(
			'https://71bva67e94.execute-api.us-east-1.amazonaws.com/dev/application/email/upsert',
			obj,
		);
	}
}
